import { css } from '@emotion/css';
import { CSSProperties } from 'react';

export const commonStyles: Record<string, CSSProperties> = {
  container: {},

  header: {
    background: 'white',
    padding: '8px',
    height: 'auto',
    lineHeight: 'normal',
    borderBottom: 'none',
    textAlign: 'left' as const,
    display: 'flex',
    alignItems: 'center',
  },

  headerWithoutBackButton: {
    background: 'white',
    padding: '8px',
    height: 'auto',
    lineHeight: 'normal',
    borderBottom: 'none',
    textAlign: 'left' as const,
  },

  content: {
    padding: '8px',
  },

  footer: {
    padding: '8px',
    background: 'white',
    textAlign: 'center' as const,
    borderTop: '1px solid #f0f0f0',
  },

  nextButton: {
    backgroundColor: 'black',
    color: 'white',
    width: '100%',
    height: '50px',
  },

  backButton: {
    marginRight: 12,
  },

  title: {
    margin: '8px 8px 8px 0px',
    textAlign: 'left' as const,
  },

  titleWithShare: {
    margin: '8px 0px',
    textAlign: 'left' as const,
    flex: 1,
  },

  headerWithShare: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px',
    gap: 8,
  },

  shareButton: {
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    width: '48px',
    height: '48px',
  },

  divider: {
    margin: '12px 0',
  },

  leftAlignedText: {
    textAlign: 'left' as const,
  },

  card: {
    borderRadius: 8,
  },

  toolContainer: {
    width: '100vw',
    maxHeight: 'calc(100dvh - 70px)',
    overflow: 'hidden',
  },

  currentQuestionContent: {
    padding: '8px 0 0 0',
    height: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
  },

  errorAlert: {
    margin: '20px',
  },

  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100dvh',
  },
};

export const emotionClasses = {
  hoverableListItem: css`
    &:hover {
      background-color: #f5f5f5;
    }
  `,

  categoryCardBody: css`
    .ant-card-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      padding: 16px 8px;
    }
  `,
};

export const styleConstants = {
  colors: {
    primary: 'black',
    success: '#52c41a',
    hover: '#f5f5f5',
    border: '#f0f0f0',
  },

  sizes: {
    borderRadius: 8,
    iconSize: 48,
    spacing: {
      xs: 4,
      sm: 8,
      md: 12,
      lg: 16,
    },
  },

  shadows: {
    card: '0 2px 8px rgba(0, 0, 0, 0.06)',
    navigation: '0 -2px 8px rgba(0, 0, 0, 0.06)',
  },
};
